import React, { useReducer, useContext } from "react";
import AuthContext from "./authContext";
import AlertContext from "../alert/alertContext";
import axios from "axios";
import authReducer from "./authReducer";
import setAuthToken from "../../utils/setAuthToken";
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
} from "../types";

const AuthState = (props) => {
  const { setAlert } = useContext(AlertContext);
  const initialState = {
    token: localStorage.getItem("auth_token"),
    user: null,
    isAuthenticated: false,
    registration_complete: null,
    password_validated: false,
    loading: true,
    error: null,
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  const updateAuthUser = (user) => {
    dispatch({
      type: USER_LOADED,
      payload: user,
    });
  };

  //   LOAD USER
  const loadUser = async () => {
    if (localStorage.auth_token) {
      setAuthToken(localStorage.auth_token);
    }
    try {
      const res = await axios.get("/api/auth");
      dispatch({ type: USER_LOADED, payload: res.data });
    } catch (err) {
      dispatch({
        type: AUTH_ERROR,
      });
    }
  };

  // REGISTER USER
  const register = async (formData) => {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    try {
      const res = await axios.post("/api/user", formData, config);
      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });
      loadUser();
    } catch (err) {
      dispatch({
        type: REGISTER_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Login User
  const loginUser = async (formData) => {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    try {
      const res = await axios.post("/api/auth", formData, config);
      if (res.data === "Login Disabled") {
        setAlert(true, "Login Disabled", "error");
        dispatch({
          type: LOGIN_FAIL,
          payload: res.data,
        });
      } else {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });
        loadUser();
      }
    } catch (err) {
      setAlert(true, "Invalid Credentials", "error");
      dispatch({
        type: LOGIN_FAIL,
        payload: err,
      });
    }
  };

  // Logout
  const logoutUser = () => dispatch({ type: LOGOUT });

  // Clear Errors
  const clearErrors = () => {
    dispatch({
      type: CLEAR_ERRORS,
    });
  };

  // EDIT USER
  const editUser = async (id, updates) => {
    const res = await axios.put(`/api/auth/${id}`, updates);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        registration_complete: state.registration_complete,
        error: state.error,
        password_validated: state.password_validated,
        register,
        loadUser,
        loginUser,
        logoutUser,
        clearErrors,
        updateAuthUser,
        editUser,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
